import { createSlice } from "@reduxjs/toolkit";
import { getAxios, postAxios, getRRAxios, postRRAxios } from "./axiosActions";
import _ from "lodash";
import toast from "../../common/toastNotistack";


export const initialState = {
    uiSections: [],
    rolePermissions: [],
    roles: [],
    loading: false,
    hasErrors: false,
};

const rolePermissionsSlice = createSlice({
  name: "rolePermissions",
  initialState,
  reducers: {
    callAPI: (state) => {
      state.loading = true;
    },
    getPermissionsSuccess: (state, { payload }) => {
      state.uiSections = payload?payload.uiSections :[];
      state.rolePermissions = payload?payload.rolePermissions :[];
      state.roles = payload?payload.roles :[];
      state.loading = false;
      state.hasErrors = false;
    },
    apiFailure: (state) => {
      state.loading = false;
      state.hasErrors = true;
    },
  },
});

export const {
   callAPI, getPermissionsSuccess,  apiFailure
} = rolePermissionsSlice.actions;
export const rolePermissionsSelector = (state) => state.rolePermissions;
export default rolePermissionsSlice.reducer;



export function fetchRolePermission() {
  return async (dispatch) => {
    dispatch(callAPI()); 
    try {
      const params = { callTime: new Date() };
      const response = await getRRAxios("api/RolePermission/GetRolePermissionData", { params: params });
    
      if(response)
      {
         dispatch(getPermissionsSuccess(response));
      }
      
    } catch (error) {
      dispatch(apiFailure());
    }
  };
} 


export const updateRolePermissions = (data) => {
  return async (dispatch) => {
    try {
      const response = await postAxios("api/RolePermission/UpdateRolePermission", { params: data,});
      
      if (response) {
        toast('Role Updated Successfully', { variant: 'success' })
         dispatch(fetchRolePermission())
      }
    } catch (error) {
      console.error("error in updateRolepermission api ")
    }
  };
};
export const updateUISection = (data) => {
  return async (dispatch) => {
    try {
      const response = await postAxios("api/RolePermission/UpdateUISection", { params: data,});
      
     dispatch(fetchRolePermission())
    } catch (error) {
      console.error("error in updateUISection api ")
    }
  };
};